import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { Panel, PanelGroup } from '@lanl-web/lanl-components';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import {
  ContentContainer,
  Filter,
  PageSections,
  QuickLinks,
  VisitBanner,
} from '../../components';

import { getTemplateComponents, renderAlert, iconMapper } from '../../utils';

import './index.scss';

const FindTemplate = ({ data, location }) => {
  const [filteredSectionGroups, setFilteredSectionGroups] = useState([]);

  const {
    directus: { rl_page },
  } = data;

  const page = rl_page.filter(
    (page) => page.introduction && page.template?.box_groups,
  )[0];

  const pageTitle = page?.title ?? '';
  const pageIntroduction = page?.introduction ?? '';
  const { pageSectionGroups, iconLinks } = getTemplateComponents(page);
  const alert = renderAlert();

  const filterPageSections = (selections) => {
    if (!selections.length) {
      setFilteredSectionGroups(pageSectionGroups);
      return;
    }

    let newGroups = [];

    pageSectionGroups?.forEach((group) => {
      const newSections = group.rl_page_sections?.filter((section) =>
        section.tags?.some((tag) =>
          selections.some((filter) => filter === tag.toUpperCase()),
        ),
      );

      newSections.length &&
        newGroups.push({
          group_heading: group.group_heading,
          rl_page_sections: newSections,
        });
    });

    setFilteredSectionGroups(newGroups);
  };

  return (
    <Layout className='find-template' location={location}>
      <SEO title={pageTitle} />

      <ContentContainer
        alert={alert}
        location={location}
        body={pageIntroduction}
        title={pageTitle}
      >
        {iconLinks && (
          <PanelGroup divider className='icon-panel panel-group'>
            {iconLinks.map(({ name, icon, url }) => {
              return (
                <Panel
                  title={name}
                  link={url}
                  icon={iconMapper(icon)}
                  key={name}
                />
              );
            })}
          </PanelGroup>
        )}

        <Filter
          filterPageSections={filterPageSections}
          pageSectionGroups={pageSectionGroups}
          setFilteredSectionGroups={setFilteredSectionGroups}
        />

        {filteredSectionGroups && (
          <PageSections pageSections={filteredSectionGroups} />
        )}
      </ContentContainer>

      <VisitBanner />
      <QuickLinks />
    </Layout>
  );
};

FindTemplate.defaultProps = {
  data: {},
  location: {},
};

FindTemplate.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export const FindTemplateQuery = graphql`
  query ($slug: String!) {
    directus {
      rl_page(
        filter: { slug: { _eq: $slug }, template: { name: { _eq: "find" } } }
      ) {
        slug
        title
        introduction
        template {
          box_groups {
            group(filter: { name: { _eq: $slug } }) {
              page_section_groups(sort: "sort") {
                group_heading
                rl_page_sections(sort: "sort") {
                  add_heading_link
                  section_heading_link
                  section_heading
                  section_content
                  tags
                }
              }
              icon_links
            }
          }
        }
      }
    }
  }
`;

export default FindTemplate;
